import React from "react";
import { Form, Typography } from "antd";
import moment from "moment";
import { getFormItemLabel } from "../../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
const { Text } = Typography;

const DateAndHourItem = (props) => {
  const { name, category, format, vertical } = props;
  const DatePickerComponent = ({ value, format }) => {
    const dateFormat = format === "date" ? "DD/MM/YYYY" : "HH:mm";
    return <Text>{value ? moment(value).format(dateFormat) : undefined}</Text>;
  };
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);

  return (
    <div>
      <Form.Item label={label} name={name}>
        <DatePickerComponent format={format} vertical={vertical} />
      </Form.Item>
    </div>
  );
};

DateAndHourItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  category: PropTypes.string,
};

export default DateAndHourItem;
